import React from "react";

import { Button, Typography } from "@mui/material";
import GoogleIcon from "@mui/icons-material/Google";
import googleLogo from "../assets/google.png";
// import GoogleButton from "react-google-button";

export default function ButtonGoogle() {
  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          gap: 10,
          padding: 4,
          border: "1px solid #ccc",
          borderRadius: 5,
          width: "100%",
        }}
      >
        {/* <Button
          startIcon={<GoogleIcon style={{ fontSize: 25, color: "crymson" }} />}
        >
          Sign With Google
        </Button> */}
        <img src={googleLogo} style={{ width: 20 }} />
        <Typography
          variant="subtitle2"
          style={{ fontSize: 14, fontWeight: 500, wordSpacing: "1px" }}
        >
          Sign In with Google
        </Typography>
      </div>
    </>
  );
}
